import { j as r } from "../../../jsx-runtime-B6kdoens.js";
import { a as m } from "../../../index-CROKJrb5.js";
import { c as f, f as u } from "../../../create-component-CBAeEoQ6.js";
const i = f(
  "CardContent",
  u(
    ({ as: o, children: c, className: e, image: t, ...s }, a) => {
      const n = o || "div";
      return /* @__PURE__ */ r.jsxs(
        n,
        {
          ref: a,
          className: m("cur-flex cur-grow cur-flex-col cur-gap-2", e),
          ...s,
          children: [
            t,
            /* @__PURE__ */ r.jsx("div", { className: "cur-flex cur-grow cur-flex-col cur-gap-2", children: c })
          ]
        }
      );
    }
  )
);
export {
  i as CardContent
};
//# sourceMappingURL=index.js.map
